import api from './api';

class UploadService {
  async uploadImage(file: File): Promise<{ image_url: string; filename: string }> {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  getImageUrl(imageUrl: string): string {
    // Se já for uma URL completa, retornar como está
    if (imageUrl.startsWith('http')) {
      return imageUrl;
    }
    // Caso contrário, construir URL completa usando a base URL da API
    const baseUrl = api.defaults.baseURL || '';
    return `${baseUrl.replace('/api', '')}${imageUrl}`;
  }
}

export const uploadService = new UploadService();
